import { render, staticRenderFns } from "./Mdm.vue?vue&type=template&id=08d1d1dc&scoped=true&"
import script from "./Mdm.vue?vue&type=script&lang=js&"
export * from "./Mdm.vue?vue&type=script&lang=js&"
import style0 from "./Mdm.vue?vue&type=style&index=0&id=08d1d1dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d1d1dc",
  null
  
)

export default component.exports